export const LANDING_SECTION_CONTAINER = "mx-auto max-w-[1680px]";

export const LANDING_SECTION_SPACING = "px-4 py-8 sm:px-6 sm:py-10 lg:px-8 lg:py-12";
